// src/main.tsx
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store";
import App from "./App";
import "./index.css";

// Initialize store on app start
import {initializeAuth} from "./store/slices/authSlice";
import {initializeUI} from "./store/slices/uiSlice";



ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
